<template>
  <div id="invoiceListComponent">
    <CCard>
      <CCardHeader>
        <CRow class="justify-content-between align-items-center px-3">
          <b>{{ title }} </b>
          <slot name="header-actions" />
        </CRow>
      </CCardHeader>
      <CCardBody>
        <slot name="filter" />
        <CDataTable
          :items-per-page="serverPagination ? pagination.limit : 25"
          :pagination="
            serverPagination ? false : { doubleArrows: false, align: 'center' }
          "
          :loading="loading"
          striped
          border
          :sorter="!serverPagination"
          :items="items"
          :fields="fields"
        >
          <td slot="pdf_file" slot-scope="{ item }">
            <CLink :href="item.pdf_file" target="_blank">
              {{ item.pdf_file }}
            </CLink>
          </td>
          <td slot="booking_no" slot-scope="{ item }">
            <span v-if="item.booking_id">
              <CLink :href="'#/bookings/' + item.booking_id">
                {{ item.booking_no ? item.booking_no : '-' }}
              </CLink>
            </span>
            <span v-else>-</span>
          </td>
          <td slot="created_at" slot-scope="{ item }">
            {{ item.created_at | moment(datetimeFormat) }}
          </td>
        </CDataTable>
        <MyPagination
          v-if="serverPagination"
          :limit="pagination.limit"
          :total="pagination.total"
          :activePage="pagination.page"
          @changePage="$emit('changePage', $event)"
          @changePageSize="$emit('changePageSize', $event)"
        />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { Common } from '@/constants';
import MyPagination from '@/components/MyPagination.vue';

export default {
  components: { MyPagination },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    serverPagination: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({ page: 1, limit: 25, total: 0 }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      datetimeFormat: Common.datetimeFormat,
      dateFormat: Common.dateFormat,
    };
  },
};
</script>
